import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { Box, Card, Divider, Grid, Switch } from '@mui/material';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot, TimelineOppositeContent } from '@material-ui/lab';
import Paper from '@material-ui/core/Paper';
import { event } from 'react-ga';
import Newtimeline from './Timeline';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
    components: {
        MuiSwitch: {
            styleOverrides: {
                track: {
                    backgroundColor: 'gray', // Altera a cor da trilha para cinza
                },
                thumb: {
                    backgroundColor: 'white', // Altera a cor do polegar para branco
                },
            },
        },
    },
});

const ActivityWorkDay = ({
    open,
    row,
    setOpenHistory,
    handleMenuOpen,
    updateTimsheet,
    handleOpenActionsModal,
    handleOpenModalUpdate,
    openModalTimesheetDelete,
    timesheetRow,
    setType,
    setRow,
    setTimesheetRow,
    succesMessage,
    data,
    schedule,
    processRow,
    ocultarPontosRemovidos,
    setOcultarPontosRemovidos,
    arrayOrdenado,
    menuTimesheet,
    setMenuTimesheet,
    diffTimeSchedule,
    loadingHistory,
    startLoading,
    setOpenAddPoint,
    handleOpenADDpoint,
    dataReportGroup
}) => {

    useEffect(() => {
        processRow(row);
        // Agora você pode usar arrayOrdenado da maneira que precisar
    }, [row, data]);


    const alternarOcultarPontosRemovidos = () => {
        setOcultarPontosRemovidos(!ocultarPontosRemovidos);
        processRow(row);
    };

    useEffect(() => {
        processRow(row);
    }, [ocultarPontosRemovidos, row]);


    function reformatarData(data) {
        try {
            if (data) {
                let partes = data.split(" - "); // Isso irá retornar ["06/05", "Segunda"]

                // Reorganiza as partes e remove o zero à esquerda do dia
                let novaData = `${partes[1]} - ${parseInt(partes[0].split("/")[0])}/${partes[0].split("/")[1]}`;

                return novaData; // Isso irá retornar: "Segunda - 6/5"
            }
        } catch (error) {
            console.log(error)
        }
    }

    const findSchedule = row?.data ? schedule[reformatarData(row?.data).split(" - ")[0]] : '00:00'
    const scheduleNow = findSchedule ? findSchedule[4] : '00:00'
    return (
        <>
            <Dialog
                open={open}
                onClose={() => setOpenHistory(false)}
                maxWidth="md"
                PaperProps={{
                    style: {
                        backgroundColor: 'white',
                        borderRadius: '20px',
                        width: '750px',
                        height: '650px'
                    },
                }}
            >
                <DialogTitle style={{
                    fontSize: '22px',
                    marginTop: '3%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    position: 'relative'  // Adicione esta linha
                }}>
                    <div style={{ alignItems: 'center' }}>
                        <Typography variant="h6" style={{
                            fontWeight: 'bold',
                            marginLeft: '16px',
                            fontFamily: 'Montserrat',
                            fontSize: '15px',
                            color: '#454a54'
                        }}
                        >Detalhes de {reformatarData(row?.data)}
                        </Typography>
                        <div style={{ display: 'flex', marginLeft: '19px' }}>
                            <Typography variant="body1" style={{
                                fontSize: '12px',
                                color: '#b6b8bc',
                                fontWeight: 'bold',
                                marginTop: '10px',
                                fontFamily: 'Montserrat'
                            }}>{ocultarPontosRemovidos ? 'Exibir' : 'Ocultar'} pontos removidos</Typography>
                            <ThemeProvider theme={theme}>
                                <Switch
                                    checked={ocultarPontosRemovidos}
                                    onChange={alternarOcultarPontosRemovidos}
                                />
                            </ThemeProvider>
                        </div>
                        <Button
                            style={{
                                marginLeft: '19px',
                                textTransform: 'none',
                                color: '#b6b8bc',
                                border: '1px solid #b6b8bc',
                                borderRadius: '15px'
                            }}
                            onClick={dataReportGroup.handleOpenAllowance}
                        >
                            Configurar abono
                        </Button>
                    </div>
                    <Card style={{
                        width: '50%',
                        height: '142px',
                        backgroundColor: '#484fdb',
                        padding: '15px',
                        position: 'absolute',
                        right: 0,
                        zIndex: 1
                    }}>
                        <Grid container style={{
                            backgroundColor: '#454a52',
                            padding: '10px',
                            zIndex: 1,
                            width: '330px',
                            height: '45px',
                            marginTop: '-10px',
                            marginLeft: '-15px',
                            borderBottomLeftRadius: '10px',
                        }}
                            justify="flex-end"
                        >
                            <Typography style={{
                                fontWeight: 'bold',
                                color: '#fff',
                                marginLeft: '205px',
                                fontFamily: 'Montserrat',
                                marginTop: '5px'
                            }}>
                                Resumo
                            </Typography>

                        </Grid>
                        <Grid style={{ marginTop: '3px' }}>
                            <Typography style={{
                                color: '#fff',
                                fontSize: '11px',
                                marginLeft: '20px',
                                display: 'flex',
                                marginBottom: '-10px',
                                fontFamily: 'Montserrat'
                            }}>
                                <p>Carga Horária</p>
                                <p style={{ marginLeft: '134px' }}>
                                    {scheduleNow}
                                </p>
                            </Typography>
                            <Divider color='#fff' style={{ width: '100%', marginBottom: '-10px' }} />
                            <Typography style={{
                                color: '#fff',
                                fontSize: '11px',
                                marginLeft: '20px',
                                display: 'flex',
                                fontFamily: 'Montserrat',
                                marginBottom: '-10px'
                            }}>
                                <p>Horas Trabalhadas</p>
                                <p style={{ marginLeft: '109px' }}>
                                    {row?.totalWorkingInMinutes ? row?.totalWorkingInMinutes + 'h' : '00:00'}
                                </p>
                            </Typography>
                            {
                                row?.allowancesAndDaysOff ?
                                    <>
                                        <Divider color='#fff' style={{ width: '100%', marginBottom: '-10px' }} />
                                        <Typography style={{
                                            color: '#fff',
                                            fontSize: '11px',
                                            marginLeft: '20px',
                                            display: 'flex',
                                            fontFamily: 'Montserrat',
                                            marginBottom: '-11px',
                                            justifyContent: 'space-between'
                                        }}>
                                            <p >
                                                Abono
                                            </p>
                                            <p
                                                style={{ marginLeft: '104px', fontSize: '9px', marginTop: '12px' }}
                                            >
                                                {row?.allowancesAndDaysOff?.displayValue}
                                            </p>
                                        </Typography>

                                    </>
                                    :
                                    null

                            }
                            {
                                row?.allowancesAndDaysOff?.value == 'ALLOWANCE_HOURS' ?
                                    <>
                                        <Divider color='#fff' style={{ width: '100%', marginBottom: '-10px' }} />
                                        <Typography style={{
                                            color: '#fff',
                                            fontSize: '11px',
                                            marginLeft: '20px',
                                            display: 'flex',
                                            fontFamily: 'Montserrat'
                                        }}>
                                            <p>Horas abonadas</p>
                                            <p style={{ marginLeft: '123px' }}>
                                                {diffTimeSchedule(row?.allowanceData?.[0].allowanceHours)}
                                            </p>
                                        </Typography>

                                    </>
                                    :
                                    null

                            }
                        </Grid>
                    </Card>
                </DialogTitle>

                <DialogContent style={{ marginTop: '38px' }}>
                    <Grid style={{ marginLeft: '-30px' }}>
                        <Newtimeline
                            dataRow={arrayOrdenado}
                            handleMenuOpen={handleMenuOpen}
                            row={row}
                            updateTimsheet={updateTimsheet}
                            handleOpenActionsModal={handleOpenActionsModal}
                            handleOpenModalUpdate={handleOpenModalUpdate}
                            openModalTimesheetDelete={openModalTimesheetDelete}
                            timesheetRow={timesheetRow}
                            setType={setType}
                            setRow={setRow}
                            setTimesheetRow={setTimesheetRow}
                            succesMessage={succesMessage}
                            setOpenHistory={setOpenHistory}
                            setMenuTimesheet={setMenuTimesheet}
                            menuTimesheet={menuTimesheet}
                            loadingHistory={loadingHistory}
                            startLoading={startLoading}
                            setOpenAddPoint={setOpenAddPoint}
                            handleOpenADDpoint={handleOpenADDpoint}
                            dataReportGroup={dataReportGroup}
                        />
                    </Grid>

                    <Typography style={{ fontSize: '14px', textAlign: 'center', marginTop: '50px' }}>
                        {arrayOrdenado?.length == 0 ? (
                            <Card
                                style={
                                    {
                                        display: 'flex',
                                        marginBottom: '20px',
                                        justifyContent: 'center',
                                        width: '255px',
                                        height: '42px',
                                        marginLeft: '29%',
                                        marginTop: '10px',
                                        borderRadius: '5px',
                                        
                                    }
                                }

                            >
                                <Button
                                    onClick={() => {
                                        handleOpenADDpoint();
                                        setOpenHistory(false);
                                    }}
                                    style={{
                                        color: '#b6b8bc',
                                        fontWeight:'bold'
                                    }}
                                >
                                    Adicionar ponto
                                </Button>
                            </Card>
                        ) : null}
                    </Typography>

                </DialogContent>

                <Box display="flex" justifyContent="center" alignItems="center" marginTop="-20px">
                    <Button
                        variant="contained"
                        style={{
                            backgroundColor: 'white',
                            color: '#4851de',
                            borderRadius: '10px',
                            marginLeft: '1.5%',
                            height: '35px',
                            marginTop: '-6%',
                            width: '17%',
                            border: '1px solid #4851de'
                        }}
                        onClick={() => setOpenHistory(false)}>
                        Fechar
                    </Button>
                </Box>

            </Dialog>
        </>
    )
}

export default ActivityWorkDay;